
import { IconButton, Typography } from "@mui/material"
import { sparePartTransactionColNm } from "./constant"
import { ArticleRounded } from "resource/muiImport"
import { numberFormat, dateFormat } from "utils"

export const sparePartTransactionColumns = [
  {
    field: 'ShowDetail',
    headerName: '',
    width: 40,
    align: 'center',
    renderCell: () => (
      <IconButton size="small">
        <ArticleRounded color="primary" />
      </IconButton>
    )
  },
  {
    field: "No",
    headerName: "No.",
    width: 50,
    align: 'center',
  },
  {
    field: "TrnsDte",
    headerName: sparePartTransactionColNm.TrnsDte,
    width: 110,
    valueFormatter: ({ value }) => dateFormat(value),
  },
  {
    field: "TrnsTyp",
    headerName: sparePartTransactionColNm.TrnsTyp,
    width: 90,
    align: 'center',
    renderCell: ({ value }) => (
      <Typography
        variant="body2"
        sx={{
          color: value === 'I' ? 'success.main' : 'error.main',
          fontWeight: 'bold',
        }}
      >
        {value === 'I' ? 'รับเข้า' : 'เบิกออก'}
      </Typography>
    )
  },
  {
    field: "SpCd",
    headerName: "รหัสอะไหล่",
    width: 120,
  },
  {
    field: "SpNm",
    headerName: "ชื่ออะไหล่",
    width: 160,
  },
  {
    field: "Qty",
    headerName: sparePartTransactionColNm.Qty,
    width: 70,
    align: "right",
  },
  {
    field: "Unt",
    headerName: "หน่วย",
    width: 60,
  },
  {
    field: "UntPr",
    headerName: sparePartTransactionColNm.UntPr,
    width: 100,
    align: "right",
    valueFormatter: ({ value }) => value ? numberFormat(value) : "-",
  },
  {
    field: "TotalPr",
    headerName: sparePartTransactionColNm.TotalPr,
    width: 100,
    align: "right",
    valueFormatter: ({ value }) => value ? numberFormat(value) : "-",
  },
  {
    field: "TukCd",
    headerName: sparePartTransactionColNm.TukId,
    width: 100,
  },
  {
    field: "SupSNm",
    headerName: sparePartTransactionColNm.SupId,
    width: 120,
  },
  {
    field: "DocNo",
    headerName: sparePartTransactionColNm.DocNo,
    width: 120,
  },
  {
    field: "Dscp",
    headerName: sparePartTransactionColNm.Dscp,
    flex: 1,
    minWidth: 120,
  },
  {
    field: "Rmk",
    headerName: sparePartTransactionColNm.Rmk,
    width: 120,
  },
]
